import { EconomicalValueChannelSourceFilters } from '@/features/broadcasters/types';
import { ParamsWithPagination } from '@/types/api';

import { EconomicalValuesFilters } from '../types';

export const economicalValuesQueryKeys = {
  all: ['economical'] as const,
  lists: () => [...economicalValuesQueryKeys.all, 'lists'] as const,
  list: (params?: Partial<EconomicalValuesFilters>) =>
    [...economicalValuesQueryKeys.lists(), params] as const,
};

export const economicalValueChannelSourcesQueryKeys = {
  all: ['economical_value_channel_sources'] as const,
  lists: () => [...economicalValueChannelSourcesQueryKeys.all, 'lists'] as const,
  list: (params?: ParamsWithPagination<EconomicalValueChannelSourceFilters>) =>
    [...economicalValueChannelSourcesQueryKeys.lists(), params] as const,
};
